import React, { useState } from 'react';
import { Banner, BlockStack, Checkbox, List, Modal, ProgressBar, Text } from '@shopify/polaris';
import { cacApi } from './apiClient';
import { chunk } from './routes';

// Confirm, then write in chunks of 25 ids with a progress bar; failures are listed per product when done.
export default function WriteModal({ ids, titleOf, onClose, onDone }) {
  const [dry, setDry] = useState(false);
  const [phase, setPhase] = useState('confirm');   // confirm | running | done
  const [progress, setProgress] = useState(0);
  const [written, setWritten] = useState([]);
  const [failed, setFailed] = useState([]);
  const [error, setError] = useState('');

  const go = async () => {
    setPhase('running'); setError(''); setProgress(0);
    const ok = []; const bad = [];
    let done = 0;
    for (const part of chunk(ids)) {
      try {
        const r = await cacApi.write(part, dry);
        ok.push(...r.written); bad.push(...r.failed);
      } catch (e) {
        // The whole chunk was refused (403 off production, 409 not approved, network): stop, say why.
        setError(e.message); setWritten(ok); setFailed(bad); setPhase('confirm');
        if (ok.length || bad.length) setPhase('done');
        return;
      }
      done += part.length; setProgress(done);
    }
    setWritten(ok); setFailed(bad); setPhase('done');
  };
  const finish = () => onDone({ written, failed, dry });
  const n = ids.length;

  return (
    <Modal open onClose={phase === 'done' ? finish : phase === 'running' ? () => {} : onClose} title={phase === 'done' ? 'Write finished' : `Write ${n} product${n === 1 ? '' : 's'} to Shopify?`}
      primaryAction={phase === 'confirm' ? { content: dry ? 'Dry run' : 'Write', onAction: go } : phase === 'done' ? { content: 'Close', onAction: finish } : { content: 'Writing…', disabled: true, loading: true }}
      secondaryActions={phase === 'confirm' ? [{ content: 'Cancel', onAction: onClose }] : []}>
      <Modal.Section>
        <BlockStack gap="300">
          {error && <Banner tone="critical" title="Not written"><p>{error}</p></Banner>}
          {phase === 'confirm' && (
            <>
              <Text as="p">Category, vendor and metafields for each of the {n} approved products, one at a time. Multi Store Sync carries them to U90 and Surf.</Text>
              <Checkbox label="Dry run (nothing is sent)" checked={dry} onChange={setDry} />
            </>
          )}
          {phase !== 'confirm' && (
            <>
              <ProgressBar progress={phase === 'done' ? 100 : Math.round((100 * progress) / n)} size="small" />
              <Text as="p" tone="subdued">{phase === 'running' ? `${progress} of ${n} done…` : `${written.length} written${dry ? ' (dry run)' : ''}, ${failed.length} failed.`}</Text>
            </>
          )}
          {phase === 'done' && failed.length > 0 && (
            <Banner tone="critical" title={`${failed.length} failed`}>
              <List>{failed.map((f) => <List.Item key={f.product_id}>{titleOf(f.product_id)}: {f.error}</List.Item>)}</List>
            </Banner>
          )}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
